module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    staticClass: "agent-apply-dialog",
    attrs: {
      "close-on-click-modal": false,
      "modal-append-to-body": false,
      "title": _vm.title,
      "lock-scroll": false,
      "visible": _vm.dialogVisible,
      "custom-class": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', [_c('h4', [_vm._v("代理商信息\n                "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.chooseAgent
    }
  }, [_vm._v("选择/切换的代理商")])], 1), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.agentInfo.Customer !== ''),
      expression: "agentInfo.Customer!==''"
    }]
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "代理商："
    }
  }, [_vm._v(_vm._s(_vm.agentInfo.Customer))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "主联系人："
    }
  }, [_vm._v(_vm._s(_vm.agentInfo.C_Name))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系人电话："
    }
  }, [_vm._v(_vm._s(_vm.agentInfo.AgentTel))])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "公司所在区域："
    }
  }, [_vm._v(_vm._s(_vm.agentInfo.Address))])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }]
  }, [_c('base-info-form', {
    ref: "baseInfo",
    attrs: {
      "value": _vm.baseInfo,
      "isRequired": true,
      "isReadOnly": _vm.isReadOnly && _vm.conpanyInfoReadOnly
    },
    on: {
      "showSelectStaffDialog": _vm.showSelectStaffDialog
    }
  }), _vm._v(" "), _c('contact-form', {
    ref: "contactAfter",
    attrs: {
      "value": _vm.contact,
      "isRequired": true,
      "isReadOnly": _vm.isReadOnly && _vm.contactInfoReadOnly
    }
  })], 1), _vm._v(" "), _c('h6', {
    staticClass: "ptitle"
  }, [_vm._v("合作信息")]), _vm._v(" "), _vm._l((_vm.agentList), function(agent, index) {
    return _c('agent-info', {
      ref: 'agentInfo' + (index + 1),
      refInFor: true,
      attrs: {
        "isReadOnly": _vm.isReadOnly && _vm.coopInfoReadOnly,
        "value": agent,
        "myIndex": (index + 1),
        "isOnlyHiInter": _vm.isOnlyHiInter
      },
      on: {
        "delAgentfn": _vm.delAgentfn,
        "flag": _vm.getFlag,
        "ProjectVal": _vm.getProject,
        "LevelVal": _vm.getLeve
      }
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确定")])], 1)], 2), _vm._v(" "), _c('selectStaffDialog', {
    ref: "refSelectStaffDialog",
    on: {
      "selectedStaff": _vm.selectedStaff
    }
  }), _vm._v(" "), _c('chooseDialog', {
    ref: "chooseDialog",
    on: {
      "dialogList": _vm.getDialogList
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-18a52fbc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CRMAgentManage/AgentAreaList/components/AddAreaDialog/index.vue
// module id = 1400
// module chunks = 1